import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/useAuth";
import styles from "./Login.module.css";

export default function Login() {
  const { user, isAdmin, isClient, loading, signInWithGoogle } = useAuth();
  const location = useLocation();
  const from = location.state?.from;

  if (loading) return null;
  if (user && isAdmin) return <Navigate to={from || "/admin"} replace />;
  if (user && isClient) {
    return <Navigate to={from?.startsWith("/portal") ? from : "/portal"} replace />;
  }

  return (
    <main className={styles.wrap}>
      <span className="mono-tag">// acceso</span>
      <h1 className={styles.h1}>
        Iniciar <span className={styles.alt}>sesión</span>
        <span className={styles.dot}>.</span>
      </h1>
      <p className={styles.lead}>
        Accede con tu cuenta de Google. Los clientes con un proyecto activo
        entran a su portal de seguimiento; las cuentas autorizadas acceden al
        panel de administración.
      </p>

      <button onClick={signInWithGoogle} className={styles.gbtn}>
        <GoogleMark />
        Continuar con Google
      </button>

      {user && !isAdmin && !isClient && (
        <p className={styles.notAdmin}>
          // estás autenticado como <strong>{user.email}</strong>, pero esta
          cuenta aún no tiene acceso. El acceso de clientes se habilita desde Aya
          Technologies — escríbenos a{" "}
          <a href="mailto:ventas@ayatech.com.pe">ventas@ayatech.com.pe</a>.
        </p>
      )}
    </main>
  );
}

function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84c-.21 1.12-.85 2.07-1.81 2.71v2.26h2.92c1.71-1.58 2.69-3.91 2.69-6.61z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.81 5.96-2.19l-2.92-2.26c-.81.55-1.85.87-3.04.87-2.34 0-4.32-1.58-5.03-3.7H.95v2.32C2.44 15.98 5.48 18 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.97 10.72A5.4 5.4 0 0 1 3.68 9c0-.6.1-1.18.29-1.72V4.96H.95A9 9 0 0 0 0 9c0 1.45.35 2.83.95 4.04l3.02-2.32z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.32 0 2.5.45 3.43 1.34l2.58-2.58C13.47.92 11.43 0 9 0 5.48 0 2.44 2.02.95 4.96l3.02 2.32C4.68 5.16 6.66 3.58 9 3.58z"
      />
    </svg>
  );
}
